import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  QueryKeys,
  useAppLocation,
  useAppState,
  useAppTranslation,
} from "../../../common";
import { ErrorModal, Modal } from "../../../components";
import { deletePoetryAction } from "../../../actions/poetry";

type ParentDeleteModalProps = {
  handleDeleteModalVisible: () => void;
};

export function PoetryDeleteModal(props: ParentDeleteModalProps) {
  const { t } = useAppTranslation();
  const location = useAppLocation();
  const queryClient = useQueryClient();

  const [state, setState] = useAppState({
    errorModalVisible: false,
  });

  const handleModalVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      errorModalVisible: !prevState.errorModalVisible,
    }));
  };

  const deletePoetry = useMutation({
    mutationKey: [QueryKeys.deletePoetryMutatuionQuery],
    mutationFn: deletePoetryAction,
    onSuccess() {
      props.handleDeleteModalVisible();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.poetryQuery] });
    },
    onError() {
      handleModalVisibility();
    },
  });

  const handleDeletePoetry = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deletePoetry.mutate({ id: location.state?.id });
  };

  return (
    <div>
      <section>
        <Modal
          onClose={props.handleDeleteModalVisible}
          title={t("poetry-page-delete-modal-title")}
          footer
          submitText={t("poetry-page-delete-submit-button-title")}
          cancelText={t("poetry-page-delete-cancel-button-title")}
          handleSubmit={handleDeletePoetry}
        >
          <span>{t("poetry-page-delete-poetry-question-label")}</span>
        </Modal>
      </section>
      <section>
        {state.errorModalVisible && (
          <ErrorModal
            error={deletePoetry.error}
            onClose={handleModalVisibility}
            title={t("poetry-page-delete-parent-error-modal-title")}
          />
        )}
      </section>
    </div>
  );
}
